import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="visibility"
export default class extends Controller {
  static targets = ["toggled"];

  show() {
    $(this.toggledTarget).slideDown(this.#triggerShowEvent);
  }

  hide() {
    $(this.toggledTarget).slideUp(this.#triggerHideEvent);
  }

  #triggerShowEvent = () => {
    this.dispatch("show", { target: this.toggledTarget });
  }

  #triggerHideEvent = () => {
    this.dispatch("hide", { target: this.toggledTarget });
  }
}
